import { Injectable } from '@angular/core';
import { Rekbot } from '../models/rekbot.model';

@Injectable({
  providedIn: 'root'
})
export class RekbotSelectsService {

  public selectedRekbots: Rekbot[] = [];
  public selectedRekbotIds: number[] = [];

  constructor() { }

  addRekbot(rekbot: Rekbot) {
    this.selectedRekbots.push(rekbot);
    this.selectedRekbotIds.push(rekbot.id);
  }

  removeRekbot(rekbot: Rekbot) {
    this.selectedRekbots = this.selectedRekbots.filter((el: Rekbot) => {
      return el.id !== rekbot.id;
    });
    this.selectedRekbotIds = this.selectedRekbotIds.filter((el: number) => {
      return el !== rekbot.id;
    });
  }

  getSelectedRekbotIds() {
    return this.selectedRekbotIds;
  }
}
